/**
 * Hotjar
 * @href https://help.hotjar.com/hc/en-us
 */
export class Hotjar {
  private static enabledLocations = [
    /^\/cabinet/
  ];

  public static id = 'hotjar';

  public static isEnabled(path: string): boolean {
    return !!path && undefined !== Hotjar.enabledLocations.find(loc => {
      return !!path.match(loc);
    });
  }

  public static getScript(trackingId: string, version: string): string {
    return `(function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:${trackingId},hjsv:${version}};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
      })(window,document,'//static.hotjar.com/c/hotjar-','.js?sv=');`;
  }

  /**
   * Initialize session
   * @param {string} trackingId
   * @param {string} version
   */
  public static createSession(trackingId: string, version: string) {
    if (Hotjar.isEnabled(window.location.pathname) && !document.getElementById(Hotjar.id)) {
      const s = document.createElement('script');
      s.id = Hotjar.id;
      s.innerHTML = Hotjar.getScript(trackingId, version);

      document.head.insertBefore(s, document.head.lastChild);
    }
  }
}
